import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center font-bold text-2xl md:text-4xl py-5" }
const _hoisted_2 = { class: "p-4" }

import { onUpdated, ref } from 'vue';
import {useStoreKey} from '@/store'
import { useRouter } from 'vue-router';
import { useBreakpoint } from 'vuestic-ui/web-components';
import { useStore } from '@/store';
import PanelSidebar from '@/components/utils/PanelSidebar.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'default',
  setup(__props) {

const store = useStore();


return (_ctx: any,_cache: any) => {
  const _component_VaButton = _resolveComponent("VaButton")!
  const _component_VaNavbarItem = _resolveComponent("VaNavbarItem")!
  const _component_VaNavbar = _resolveComponent("VaNavbar")!
  const _component_VaLayout = _resolveComponent("VaLayout")!

  return (_openBlock(), _createBlock(_component_VaLayout, {
    style: {"height":"100%","min-height":"100vh"},
    left: { absolute: _ctx.$vaBreakpoint.smDown }
  }, {
    top: _withCtx(() => [
      _createVNode(_component_VaNavbar, {
        color: "color1",
        class: "py-2",
        gradient: ""
      }, {
        left: _withCtx(() => [
          _createVNode(_component_VaButton, {
            icon: _unref(store).state.ui.showSidebar ? 'menu_open' : 'menu',
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).state.ui.showSidebar = !_unref(store).state.ui.showSidebar)),
            color: "color1"
          }, null, 8, ["icon"])
        ]),
        center: _withCtx(() => [
          _createVNode(_component_VaNavbarItem, { class: "font-bold text-lg" }, {
            default: _withCtx(() => [
              _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(useRouter)().currentRoute.value.meta.routeTitle), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    left: _withCtx(() => [
      _createVNode(PanelSidebar, { class: "col-span-1" })
    ]),
    content: _withCtx(() => [
      _createElementVNode("main", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["left"]))
}
}

})